import { render } from "./roomingList.vue?vue&type=template&id=255f53d3&scoped=true"
import script from "./roomingList.vue?vue&type=script&lang=js"
export * from "./roomingList.vue?vue&type=script&lang=js"

import "./roomingList.vue?vue&type=style&index=0&id=255f53d3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255f53d3"]])

export default __exports__